import useGetInternalWidgetConfig from '@hooks/api/queries/useGetInternalWidgetConfig';
import { generateMqttClient } from '@pages/_loader/initMqttClient.loader';
import { WidgetTypeDeviceList } from '@src/types/Widget';
import { MqttClient } from 'mqtt';
import React, { useEffect } from 'react';
import DeviceDataTable from '@src/components/_shared/DeviceDataTable';
import { Box } from '@mui/material';

function PowinBessRackList({
  selectedBessId,
}: {
  selectedBessId: string;
}) {
  const [mqttClient, setMqttClient] = React.useState<MqttClient>();

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    const startClient = async () => {
      const client = await generateMqttClient();
      setMqttClient(client);
    };
    startClient();
    return () => {
      mqttClient?.end();
    };
  }, []);

  const { data: widgetConfig } =
    useGetInternalWidgetConfig<WidgetTypeDeviceList>(
      'powinRackList',
      {
        sourceDeviceId: selectedBessId,
      },
      { enabled: !!selectedBessId },
    );

  return (
    <Box
      sx={{
        mt: 3,
      }}
    >
      {widgetConfig ? (
        <DeviceDataTable
          id='bess_rack'
          hideFooter
          additionalClassnames='detail-data-table'
          devices={widgetConfig?.devices || []}
          dataPoints={widgetConfig?.dataPoints || []}
          pointConfigRefs={widgetConfig?.pointConfigRefs || []}
          mqttClient={mqttClient}
        />
      ) : (
        <></>
      )}
    </Box>
  );
}

export default PowinBessRackList;
